import { Component, inject, OnInit } from '@angular/core';
import { Session } from "../../../../services/session.service";
import { RouterLink } from "@angular/router";
import {PermissionService} from "../../../../services/permissions.service";

@Component({
  selector: 'app-header-account-info',
  imports: [
    RouterLink
  ],
  templateUrl: './header-account-info.component.html',
  styleUrl: './header-account-info.component.scss'
})
export class HeaderAccountInfoComponent implements OnInit {
  private readonly session:Session = inject(Session);
  private readonly permissions = inject(PermissionService);
  daysLeft: number = 0;
  expirationMessage: string = "";
  canManageAccount: boolean = false;
  isPlanEnding: boolean = false;

  ngOnInit() {
    const accountStatus = this.session.getAccountStatus();

    const nextBillingDate = accountStatus.subscription.nextBillingDate;
    let endDate: Date | undefined = undefined;
    if (nextBillingDate) {
      const parsedDate = new Date(nextBillingDate);
      if (!isNaN(parsedDate.getTime())) {
        parsedDate.setDate(parsedDate.getDate() - 1);
        endDate = parsedDate;
      }
    }
    endDate = endDate || new Date();
    if(accountStatus.subscription.isTrial && endDate && accountStatus.status === 'ok') {
      this.isPlanEnding = true;
    }
    this.daysLeft = this.calculateDaysLeft( endDate );
    if(this.daysLeft <= 1) {
      this.expirationMessage = "This is your last day.";
    }
    else {
      this.expirationMessage = `${this.daysLeft} days of your Free Trial remain.`;
    }
    this.canManageAccount =  this.permissions.getPermission('accountPermissions', 'manageAccount');
  }

  private calculateDaysLeft( endDate: Date | undefined ): number {
    if( !endDate ) return 0;
    const today = new Date();
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil( diffTime / ( 1000 * 60 * 60 * 24 ) );
    return Math.max( 0, diffDays );
  }
}
